import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "@fluentui/react/lib/Checkbox";
import Select from "react-select";

import { TEXT } from "../../../../../shared/constants/texts";
import { setIsMajorVersion, setSelectedVersionLabel } from "../../../redux/slice";

const AgreementVersionAdvanced = () => {
  const dispatch = useDispatch();
  const state = useSelector((state: any) => state.addToIciSlice);
  const {
    isMajorVersionConfigured,
    isVersionLabelsConfigured,
    versionLabels,
    majorVersionLocalizedString,
    isMajorVersion,
    selectedVersionLabel,
  } = state;

  const onChangeIfMajorVersion = (_ev, checked) => {
    dispatch(setIsMajorVersion(!!checked));
  };

  const onVersionLabelChangeHandler = (data) => {
    dispatch(setSelectedVersionLabel(data));
  };

  const majorVersionCheckBoxStyles = {
    checkbox: {
      width: "0.8125rem",
      height: "0.8125rem",
      marginTop: "0.25rem",
    },
    text: {
      width: "75vw",
      fontSize: "0.8125rem",
      wordWrap: "break-word",
    },
  };

  const showAgreementNewVersionAdvancedOptions = isMajorVersionConfigured || isVersionLabelsConfigured;

  return showAgreementNewVersionAdvancedOptions ? (
    <div className="advanced-versioning-add-to-ici">
      {isMajorVersionConfigured ? (
        <div className="major-version-add-to-ici">
          <Checkbox
            styles={majorVersionCheckBoxStyles}
            label={majorVersionLocalizedString}
            checked={isMajorVersion}
            onChange={onChangeIfMajorVersion}
          />
        </div>
      ) : null}
      {isVersionLabelsConfigured ? (
        <div className="version-label-container">
          <label htmlFor="version-label-add-to-ici">{TEXT.VERSION_LABEL}</label>
          <div className="version-label-container-a11y" tabIndex={1}>
            <Select
              aria-labelledby="version-label-add-to-ici"
              inputId="version-label-add-to-ici"
              name="version-label-add-to-ici"
              placeholder={TEXT.SELECT_LABEL}
              options={versionLabels}
              styles={versionLabelDropdownStyles}
              isClearable
              value={selectedVersionLabel}
              onChange={(option) => onVersionLabelChangeHandler(option)}
              noOptionsMessage={() => <p className="empty-message">{TEXT.NO_LABEL}</p>}
              components={{
                IndicatorSeparator: () => null,
              }}
              menuPlacement="auto"
            />
          </div>
        </div>
      ) : null}
    </div>
  ) : (
    <React.Fragment></React.Fragment>
  );
};

const versionLabelDropdownStyles = {
  menu: (styles: any) => ({
    ...styles,
    border: "0.0625rem solid #a6a6a6",
    boxShadow: "none",
    marginTop: "-0.25rem",
  }),
  placeholder: (styles: any) => ({
    ...styles,
    backgroundColor: "#fff",
    color: "#000",
  }),
  control: (styles: any) => ({
    ...styles,
    marginTop: "0.125rem",
    backgroundColor: "#fff",
    border: "0.0625rem solid #a6a6a6",
    boxShadow: "none",
    "&:hover": {
      border: "0.0625rem solid #a6a6a6",
    },
    fontSize: "0.75rem",
    borderRadius: "0",
    height: 32,
    minHeight: 32,
  }),
  valueContainer: (styles) => ({
    ...styles,
    height: 32,
    padding: 4,
    marginTop: "-0.125rem",
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    height: 32,
    marginTop: "-0.0625rem",
  }),
  option: (styles: { [x: string]: any }, { isFocused, isSelected }: any) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#0078d4" : isFocused ? "#f3f2f1" : "#fff",
      outline: isFocused ? "1px solid #00a2ed" : null,
      cursor: isFocused ? "pointer" : "default",
      ":active": {
        ...styles[":active"],
        backgroundColor: "#0078d4",
      },
      borderRadius: "0.25rem",
      fontSize: "0.75rem",
    };
  },
  group: (styles) => {
    return {
      ...styles,
      backgroundColor: "#ebeae8",
      padding: 0,
      marginTop: "-0.25rem",
    };
  },
};

export default AgreementVersionAdvanced;
